module.exports = __webpack_public_path__ + "static/media/ccd_logo.6169b501.png";